import { fixUrl } from '@/utils/helpers';
import { SG_EVENT_NAMES } from '@/utils/tools/segment/eventNames';
import { trackEvent } from '@/utils/tools/segment/tracking';
import { Button, Flex, Form, Input, Progress, Typography, Upload, message } from 'antd';
import axios from 'axios';
import Image from 'next/image';
import { useState } from 'react';
import styles from './brand.module.css';
const { Title } = Typography;

export default function EditBrandFrom({ brand, onChange }) {
   const [loading, setLoading] = useState(false);

   async function onfinish(values) {
      setLoading(true);
      if (brand) {
         const newBrand = await axios.patch('/api/brands/' + brand._id, values);
         onChange(newBrand.data.brand);
         setLoading(false);
         return;
      }
      if (!brand) {
         const newBrand = await axios.post('/api/brands', values);
         trackEvent(SG_EVENT_NAMES.USER_CREATE_BRAND, { brandId: newBrand.data._id });
         onChange(newBrand.data);
         setLoading(false);
      }
   }

   return (
      <>
         <Flex vertical justify="center" align="center" gap={32} style={{ width: '100%' }}>
            <Title level={3}>{brand ? 'Edit Brand' : 'Create new Brand'}</Title>
            <Form
               size="large"
               layout="vertical"
               style={{ width: '100%' }}
               onFinish={onfinish}
               className={styles.editForm}
               initialValues={brand}
            >
               <Flex vertical justify="center" align="center" style={{ width: '100%' }}>
                  <Form.Item name={'icon'}>
                     <ImageUploader defaultImage={brand?.icon} width={100} height={100} />
                  </Form.Item>

                  <Form.Item style={{ width: '100%' }} name={'name'} required rules={[{ required: true }]}>
                     <Input placeholder="Brand Name" />
                  </Form.Item>

                  <Form.Item name={'cover'} required rules={[{ required: false }]}>
                     <ImageUploader defaultImage={brand?.cover} width={400} height={100} />
                  </Form.Item>

                  <Form.Item style={{ width: '60%', minWidth: '300px', marginTop: '1rem' }}>
                     <Button loading={loading} type="primary" htmlType="submit" style={{ width: '100%' }}>
                        {brand ? 'Save' : 'Create'}
                     </Button>
                  </Form.Item>
               </Flex>
            </Form>
         </Flex>
      </>
   );
}

function ImageUploader({ defaultImage, width, height, ...props }) {
   const [progress, setProgress] = useState(0);
   const [imageUrl, setImageUrl] = useState(fixUrl(defaultImage));
   const [uploading, setUploading] = useState(false);

   function handleBeforeUpload(file) {
      // check file size lower than 2MB
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isLt2M) {
         message.error('Image must smaller than 2MB!');
      }
      return isLt2M;
   }

   function handleChange(info) {
      let fileList = [...info.fileList];

      // 1. set the progress
      setProgress(info.file.percent);
      if (info.file.status === 'uploading') {
         setUploading(true);
         return;
      }
      if (info.file.status === 'done') {
         setUploading(false);
      }

      // 2. Read from response and show file link
      fileList = fileList.map((file) => {
         if (file.response) {
            // Component will show file.url as link
            file.url = file.response.url;
            setImageUrl(file.response.url);
         }
         return file;
      });
      props.onChange(fileList[0].url);
   }

   return (
      <Upload
         showUploadList={false}
         beforeUpload={handleBeforeUpload}
         onChange={handleChange}
         maxCount={1}
         multiple={false}
         action={`/api/upload?public=true`}
         accept="image/*"
         style={{ width: '100%' }}
      >
         <div className={styles.uploadContainer} style={{ width: width, height: height }}>
            <div className={styles.uploadInner + ' ' + (imageUrl ? styles.uploaded : '')}>
               <Flex vertical justify="center" align="center" style={{ width: '100%' }}>
                  {uploading && <Progress type="circle" percent={progress} width={20} />}
                  {!uploading && <i className="fi fi-rr-cloud-upload-alt" />}
                  <p>Upload</p>
               </Flex>
            </div>
            {imageUrl && <Image className={styles.uploadImage} src={imageUrl} alt="avatar" width={100} height={100} />}
         </div>
      </Upload>
   );
}
